/* tslint:disable */
import { Observable } from 'rxjs';
import { Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent } from '@angular/common/http';

import {
  BaseApiClient,
  RequestContext,
  ApiConfigManager,
  HttpRequestState
} from '@sg/api/base-api-lib';
import { BroadcastApiConfig } from '../api-config';

import { BroadcastApi } from '../models';

@Injectable()
export class BroadcastTransmissionApiClient extends BaseApiClient<BroadcastApiConfig> {
  constructor(httpClient: HttpClient, config: ApiConfigManager) {
    super(httpClient, config.broadcastApiConfig);
  }

  transmissionControllerCreateTransmission(
    body: BroadcastApi.TransmissionCreateDto,

    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<BroadcastApi.Transmission>;
  transmissionControllerCreateTransmission(
    body: BroadcastApi.TransmissionCreateDto,

    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<HttpResponse<BroadcastApi.Transmission>>;
  transmissionControllerCreateTransmission(
    body: BroadcastApi.TransmissionCreateDto,

    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<BroadcastApi.Transmission>;
  transmissionControllerCreateTransmission(
    body: BroadcastApi.TransmissionCreateDto,

    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpRequestState<BroadcastApi.Transmission>>;
  transmissionControllerCreateTransmission(
    body: BroadcastApi.TransmissionCreateDto,

    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpResponse<BroadcastApi.Transmission>>;
  transmissionControllerCreateTransmission(
    body: BroadcastApi.TransmissionCreateDto,

    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpEvent<BroadcastApi.Transmission>>;
  transmissionControllerCreateTransmission(
    body: BroadcastApi.TransmissionCreateDto,

    options: {
      observe?: 'responsePromise' | 'bodyPromise' | 'response' | 'body' | 'bodyWithState' | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {}
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['body', body]);

    const consumes = ['application/json'];

    requestContext.headers = this.createHeaders(options.headers || {});

    this.setAcceptHeader(requestContext, 'application/json');

    this.setContentTypeHeader(requestContext, ...consumes);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.post<BroadcastApi.Transmission>(
      `${this.basePath}/gateway/admin/broadcast/transmission`,
      body,
      <any>Object.assign(baseOptions, {})
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  transmissionControllerUpdateTransmission(
    params: { body: BroadcastApi.TransmissionCreateDto; id: string },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<BroadcastApi.Transmission>;
  transmissionControllerUpdateTransmission(
    params: { body: BroadcastApi.TransmissionCreateDto; id: string },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<HttpResponse<BroadcastApi.Transmission>>;
  transmissionControllerUpdateTransmission(
    params: { body: BroadcastApi.TransmissionCreateDto; id: string },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<BroadcastApi.Transmission>;
  transmissionControllerUpdateTransmission(
    params: { body: BroadcastApi.TransmissionCreateDto; id: string },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpRequestState<BroadcastApi.Transmission>>;
  transmissionControllerUpdateTransmission(
    params: { body: BroadcastApi.TransmissionCreateDto; id: string },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpResponse<BroadcastApi.Transmission>>;
  transmissionControllerUpdateTransmission(
    params: { body: BroadcastApi.TransmissionCreateDto; id: string },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpEvent<BroadcastApi.Transmission>>;
  transmissionControllerUpdateTransmission(
    params: { body: BroadcastApi.TransmissionCreateDto; id: string },
    options: {
      observe?: 'responsePromise' | 'bodyPromise' | 'response' | 'body' | 'bodyWithState' | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {}
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['body', params.body], ['id', params.id]);

    const consumes = ['application/json'];

    requestContext.headers = this.createHeaders(options.headers || {});

    this.setAcceptHeader(requestContext, 'application/json');

    this.setContentTypeHeader(requestContext, ...consumes);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.put<BroadcastApi.Transmission>(
      `${this.basePath}/gateway/admin/broadcast/transmission/${this.encodeURI(String(params.id))}`,
      params.body,
      <any>Object.assign(baseOptions, {})
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  transmissionControllerGetTransmissionById(
    id: string,

    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<BroadcastApi.Transmission>;
  transmissionControllerGetTransmissionById(
    id: string,

    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<HttpResponse<BroadcastApi.Transmission>>;
  transmissionControllerGetTransmissionById(
    id: string,

    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<BroadcastApi.Transmission>;
  transmissionControllerGetTransmissionById(
    id: string,

    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpRequestState<BroadcastApi.Transmission>>;
  transmissionControllerGetTransmissionById(
    id: string,

    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpResponse<BroadcastApi.Transmission>>;
  transmissionControllerGetTransmissionById(
    id: string,

    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpEvent<BroadcastApi.Transmission>>;
  transmissionControllerGetTransmissionById(
    id: string,

    options: {
      observe?: 'responsePromise' | 'bodyPromise' | 'response' | 'body' | 'bodyWithState' | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {}
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['id', id]);

    requestContext.headers = this.createHeaders(options.headers || {});

    this.setAcceptHeader(requestContext, 'application/json');

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.get<BroadcastApi.Transmission>(
      `${this.basePath}/gateway/admin/broadcast/transmission/${this.encodeURI(String(id))}`,
      <any>Object.assign(baseOptions, {})
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  transmissionControllerSearchTransmissions(
    params: {
      body: BroadcastApi.TransmissionSearchRequestDto;
      pageSize?: number;
      pageNumber?: number;
      order?: 'asc' | 'desc';
      orderBy?: 'name' | 'createDate' | 'updateDate';
      sortDirection?: 'asc' | 'desc';
    },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<BroadcastApi.TransmissionSearchResponse>;
  transmissionControllerSearchTransmissions(
    params: {
      body: BroadcastApi.TransmissionSearchRequestDto;
      pageSize?: number;
      pageNumber?: number;
      order?: 'asc' | 'desc';
      orderBy?: 'name' | 'createDate' | 'updateDate';
      sortDirection?: 'asc' | 'desc';
    },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<HttpResponse<BroadcastApi.TransmissionSearchResponse>>;
  transmissionControllerSearchTransmissions(
    params: {
      body: BroadcastApi.TransmissionSearchRequestDto;
      pageSize?: number;
      pageNumber?: number;
      order?: 'asc' | 'desc';
      orderBy?: 'name' | 'createDate' | 'updateDate';
      sortDirection?: 'asc' | 'desc';
    },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<BroadcastApi.TransmissionSearchResponse>;
  transmissionControllerSearchTransmissions(
    params: {
      body: BroadcastApi.TransmissionSearchRequestDto;
      pageSize?: number;
      pageNumber?: number;
      order?: 'asc' | 'desc';
      orderBy?: 'name' | 'createDate' | 'updateDate';
      sortDirection?: 'asc' | 'desc';
    },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpRequestState<BroadcastApi.TransmissionSearchResponse>>;
  transmissionControllerSearchTransmissions(
    params: {
      body: BroadcastApi.TransmissionSearchRequestDto;
      pageSize?: number;
      pageNumber?: number;
      order?: 'asc' | 'desc';
      orderBy?: 'name' | 'createDate' | 'updateDate';
      sortDirection?: 'asc' | 'desc';
    },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpResponse<BroadcastApi.TransmissionSearchResponse>>;
  transmissionControllerSearchTransmissions(
    params: {
      body: BroadcastApi.TransmissionSearchRequestDto;
      pageSize?: number;
      pageNumber?: number;
      order?: 'asc' | 'desc';
      orderBy?: 'name' | 'createDate' | 'updateDate';
      sortDirection?: 'asc' | 'desc';
    },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpEvent<BroadcastApi.TransmissionSearchResponse>>;
  transmissionControllerSearchTransmissions(
    params: {
      body: BroadcastApi.TransmissionSearchRequestDto;
      pageSize?: number;
      pageNumber?: number;
      order?: 'asc' | 'desc';
      orderBy?: 'name' | 'createDate' | 'updateDate';
      sortDirection?: 'asc' | 'desc';
    },
    options: {
      observe?: 'responsePromise' | 'bodyPromise' | 'response' | 'body' | 'bodyWithState' | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {}
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['body', params.body]);

    const consumes = ['application/json'];

    requestContext.queryParams = this.createQueryParams(
      ['', 'pageSize', params.pageSize],
      ['', 'pageNumber', params.pageNumber],
      ['', 'order', params.order],
      ['', 'orderBy', params.orderBy],
      ['', 'sortDirection', params.sortDirection]
    );

    requestContext.headers = this.createHeaders(options.headers || {});

    this.setAcceptHeader(requestContext, 'application/json');

    this.setContentTypeHeader(requestContext, ...consumes);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.post<BroadcastApi.TransmissionSearchResponse>(
      `${this.basePath}/gateway/admin/broadcast/transmission/search`,
      params.body,
      <any>Object.assign(baseOptions, {})
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }
}
